export const DEFAULT_SNACKBAR_CONTAINER = 'c-snackbar';
//# sourceMappingURL=constants.js.map